<template>
  <div style="height: 100%">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <div class="title">
        <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
        <!-- <h3>角色设置</h3> -->
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="add">添加角色</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table style="padding-bottom: 40px" v-horizontal-scroll="'always'" :column="columns" :data="roleList"
          :total="page.totalNum" pagination layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="page.currentPage" :page-size="page.pageSize"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="isEdit" width="526px" :append-to-body="true">
      <template>
        <el-form :inline="true" label-width="100px" size="small">
          <el-form-item label="角色名称">
            <el-input v-model="name" placeholder="请输入角色名称" style="width: 300px">
            </el-input>
          </el-form-item>
        </el-form>

        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isEdit = false">取消</div>
          <div class="info-s" @click="addRole">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="修改权限" :visible.sync="isRole" width="487px" top="8vh" :append-to-body="true">
      <template v-if="isRole">
        <div style="width: 100%; height: 680px; overflow-y: auto">
          <el-tree :data="roleLimits" show-checkbox node-key="id" ref="tree" default-expand-all
            :default-checked-keys="selectedLimits" :props="defaultProps" style="width: 100%">
            <div slot-scope="{ node, data }">
              <div v-if="node.level == 1" style="
                  width: 400px;
                  margin-bottom: 10px;
                  border-bottom: 1px solid #ebebfa;
                ">
                <div style="width: 400px; height: 50px; line-height: 55px">
                  {{ node.label }}
                </div>
                <!-- <div style="height: 1px; background: #ebebfa"></div> -->
              </div>
              <div v-if="node.level == 2" style="
                  width: 384px;
                  border-bottom: 1px solid #ebebfa;
                  margin-bottom: 10px;
                ">
                <div style="height: 55px; line-height: 64px">
                  {{ node.label }}
                </div>
              </div>
            </div>
          </el-tree>
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <!-- <div class="info-q" @click="isRole = false">取消</div> -->
          <div class="info-s" @click="getSelected">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
          是否确认删除，删除后数据不可恢复！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isD = false">取消</div>
          <div class="info-s" @click="submitD">确定</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      title: '添加角色',
      isEdit: false,
      isRole: false,
      name: '',
      dataList: {
        list: [
          { title: '系统管理', path: '', type: '0' },
          { title: '角色设置', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '角色设置', path: '', type: '0' },
        ]
      },
      isD: false,
      searchForm: {
        name: '', // 	否 	string 	商品名称
        goodsNo: '', // 	否 	string 	商品编号
        categoryId: '', // 	否 	int 	类目id（数据来源：接口 - /order/comm/commodityCategory/commList）
        brandId: '', // 	否 	int 	品牌id（数据来源：接口 - /order/comm/brand/list?pageNo=1&pageSize=999）
        goodsType: '', // 	否 	int 	类型（1：普通商品；2：虚拟商品；3：赠品；字典：goods_type）
        status: '', // 	否 	int 	状态（字典：sale_status）
        orderBy: '', // 	否 	int 	排序（0价格；1可用库存；2总销量）
        orderByType: '' // 	否 	int 	排序方式（0正序；1倒序）
      },
      value1: [],
      brandList: [],
      columns: [
        { label: '角色名称', prop: 'name', minWidth: '120' },
        {
          label: '角色权限', minWidth: '220',
          render: (h, scope) => {
            if (!scope.row.menuNames) { return }
            return (
              <div style="display:flex;flex-wrap:wrap;">
                {
                  scope.row.menuNames.map(item => {
                    return (
                      <div style="padding:4px 8px;background:#EBEEFA;border-radius: 3px;font-size:14px;margin-right:12px;display:inline-block;margin-bottom:10px;">{item}</div>
                    )
                  })
                }
              </div>

            )
          }
        },
        { label: '创建时间', prop: 'createdTime', minWidth: '100' },
        {
          label: '操作',
          width: '200',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.edit(scope.row) }}>修改名称</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.getRoleLimits(scope.row) }}>权限设置</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteD(scope.row.id) }}>删除</span>
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      roleList: [],
      loading: true,
      roleLimits: JSON.parse(sessionStorage.getItem('limit')).menuTreeList,
      roleId: null,
      selectedLimits: [],
    }
  },
  created() {
    this.getRoleList()
    console.log(this.roleLimits)
  },
  methods: {
    deleteD(id) {
      this.isD = true
      this.roleId = id
    },
    submitD() {
      let ids = []
      ids.push(this.roleId)
      let data = {
        ids: ids
      }
      this.axios.post('/sysRole/delete', data)
        .then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功')
            this.isD = false
            this.getRoleList()

          }

        })
    },
    getSelected() {
      let menuIds = this.$refs.tree.getCheckedKeys(false, true)
      let dd = this.$refs.tree.getHalfCheckedKeys()
      menuIds = menuIds.concat(dd)
      menuIds = [...new Set(menuIds)]
      console.log('dd==', dd)
      console.log('menuIds=', menuIds)
      // return
      if (menuIds.length == 0) {
        return this.$message.warning('请选择角色权限')
      }
      let data = {
        id: this.roleId,
        menuIds: menuIds
      }
      this.axios.post('/sysRole/saveMenuList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.isRole = false;
            this.getRoleList()
          }
        })

    },
    getRoleLimits(row) {
      this.selectedLimits = []
      this.roleId = row.id;
      this.axios.get('/sysRole/getMenuList?id=' + row.id)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.isRole = true;
            // this.roleLimits = res.data;
            this.selectedLimits = res.data.map(item => {
              return item.id
            })


            if (res.data.length > 0) {
              console.log(res.data)

              for (let i = res.data.length - 1; i >= 0; i--) {
                if (res.data[i].name == '用户管理' || res.data[i].name == '商品管理' || res.data[i].name == '订单管理' || res.data[i].name == '财务管理' || res.data[i].name == '营销管理' || res.data[i].name == '系统管理' || res.data[i].name == 'APP设置' || res.data[i].name == '基本设置') {
                  res.data.splice(i, 1)
                  // console.log(row.menuList[i].name)
                }
              }
              this.selectedLimits = res.data.map(item => {
                return item.id
              })
              // this.selectedLimits.splice(1,1)
              console.log(this.selectedLimits)
            } else {
              console.log(5555555)
              this.selectedLimits = []
            }
            this.$forceUpdate()
          }
        })
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getRoleList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getRoleList()
    },
    addRole() {
      if (this.roleId) {
        let data = {
          id: this.roleId,
          name: this.name
        }
        this.axios.post('/sysRole/update', data)
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.isEdit = false
              this.$message.success('修改成功！')
              this.getRoleList()
            }
          })
      } else {
        let data = {
          name: this.name
        }
        this.axios.post('/sysRole/add', data)
          .then(res => {
            console.log(res)
            if (res.code == 0) {
              this.isEdit = false
              this.$message.success('添加成功！')
              this.getRoleList()
            }
          })
      }

    },
    getRoleList() {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.axios.post('/sysRole/getPageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.roleList = res.data.list;
            this.page.totalNum = res.data.totalNum
          }

        })
    },
    add() {
      this.isEdit = true
      this.title = '添加角色'
      this.name = ''
      this.roleId = ''
    },
    edit(row) {
      this.name = row.name;
      this.roleId = row.id;
      this.isEdit = true
      this.title = '编辑角色'
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 55px;
  cursor: pointer;
}

// 自定义图标中隐藏自带箭头
::v-deep .el-tree-node__content>.el-tree-node__expand-icon {
  position: absolute;
  opacity: 0;
}

::v-deep .el-tree-node__content {
  position: relative;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 80px;
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

.limits-item {}
</style>

